const ErrorFallback = () => <div>Sorry, something has gone wrong.</div>;

export default ErrorFallback;
